<template>
    <v-card class="rounded-lg">
        <v-card-title>100ms.live Settings</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <div class="text-h5 mb-4">API Connection</div>
            <v-row>
                <v-col>
                    <p>100ms is the backend service provider that empowers the audio and video services. It's free to create
                        an account and it comes with 10,000 free video conference minutes each month. Recording is billed at $0.016/minute. 
                        If you need more than 10,000 minutes, you will receive an invoice each month for minutes over 10,000 and all recording minutes. 
                        Additional meeting minutes are $0.004.
                    </p>

                    <v-btn href="https://dashboard.100ms.live/register" target="_blank" color="primary" class="mb-8">
                        Create Free Account
                        <v-icon class="ml-2">mdi-open-in-new</v-icon>
                    </v-btn>
                    
                </v-col>
                <v-col>
                    <v-responsive :aspect-ratio="16/9">
                        <iframe src="https://www.loom.com/embed/c4f7c0e04f6d40019e1974cfcf0facad" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                    </v-responsive>
                </v-col>
            </v-row>

            <p>Once you have your account, log in and go to the "Developer" menu on the left in your 100ms.live account. 
                        Locate the "App Access Key" and "App Secret", then copy and paste those values here, and save your changes.</p>
                    
            <v-text-field :loading="loading" type="password" outlined label="100ms App Access Key" v-model="settings.app_access_key"></v-text-field>
            <v-text-field :loading="loading" type="password" outlined label="100ms App Secret" v-model="settings.app_secret"></v-text-field>

            <div class="text-h6">Enable Webhook</div>
            <p>In order to get your recordings, you'll need to enable the webhook option on the developer section and copy and paste this URL into the Webhook URL field:</p>
            <v-alert prominent type="info">
                <v-row align="center">
                    <v-col class="grow">
                        https://{{domain}}/wp-json/dialer-now/meeting/webhook
                    </v-col>
                    <v-col class="shrink">
                        <v-btn icon @click="copyURL(`https://${domain}/wp-json/dialer-now/meeting/webhook`)"><v-icon>mdi-content-copy</v-icon></v-btn>
                    </v-col>
                </v-row>
        </v-alert>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="ma-2" :loading="saving" @click="saveSettings()" color="primary">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>


<script>
import { useUserStore } from '../../stores/user'

export default {
    name: 'OneHundredMsSettings',
    created: function() {
        this.user = useUserStore()
    },
    data: function() {
        return {
            user: null,
            loading: false,
            saving: false,
            settings: {
                app_access_key: '',
                app_secret: '',
            }
        }
    },
    mounted: function() {
        this.loadSettings()
    },
    computed: {
        domain: function() {
            return window.location.host
        }
    },
    methods: {
        async copyURL(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.user.app.showSuccess("Copied to clipboard!")
            } catch($e) {
                console.error($e)
            }
        },
        loadSettings: function() {
            this.loading = true
            this.user.app.get('meeting/100ms').then(response => {
                if(response.data['100ms'] != '')
                    this.settings = response.data['100ms']
                this.loading = false
            })
        },
        saveSettings: function() {
            this.saving = true
            this.user.app.post('meeting/100ms', { settings: this.settings })
                .then(() => {
                    this.saving = false
                    this.user.app.showSuccess('Settings saved')
                    window.location.reload()
                })
                .catch(error => {
                    this.saving = false
                    this.user.app.showError(error.response.data.toUpperCase())
                    console.error(error)
                })
        }
    }
}
</script>